import React from "react";
import { STEP_CONFIG, BookingStep } from "../constants";

interface BookingStepIndicatorProps {
  currentStep: BookingStep;
}

const BookingStepIndicator: React.FC<BookingStepIndicatorProps> = ({ currentStep }) => {
  return (
    <div className="w-full max-w-3xl mx-auto mb-8">
      <div className="flex items-center justify-between">
        {STEP_CONFIG.map((stepItem, index) => (
          <div key={stepItem.id} className="flex items-center flex-grow">
            <div className="flex flex-col items-center">
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center ${
                  currentStep >= stepItem.id
                    ? "bg-red-500 text-white"
                    : "bg-gray-200 text-gray-500"
                }`}
              >
                {currentStep > stepItem.id ? "✓" : stepItem.id}
              </div>
              <span className="text-xs mt-1">{stepItem.title}</span>
            </div>
            {index < STEP_CONFIG.length - 1 && (
              <div className="h-[2px] flex-grow mx-2 bg-gray-200">
                {currentStep > stepItem.id && (
                  <div
                    className="h-full bg-red-500"
                    style={{ width: "100%" }}
                  ></div>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default BookingStepIndicator;